module.exports = __webpack_public_path__ + "img/title11.0ca49764.png";